import {
  ScreenerSettingName,
  useIsScreenerSettingEnabledForAnyFacility
} from '@/hooks/screener-settings';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { UserDynamicPermissions } from '@/pages/AdminHub/Staff/hooks/useDynamicPermissionQuery';

export const useIsMedicaidPendingAvailable = (): boolean | undefined => {
  const currentUser = useCurrentUser().data;
  const isEnabledForAnyFacility = useIsScreenerSettingEnabledForAnyFacility(
    ScreenerSettingName.MedicaidPendingEnabled
  );
  const canViewCases =
    currentUser?.enabled_dynamic_permissions?.includes(
      UserDynamicPermissions.MEDICAID_PENDING_VIEW_CASES
    ) ?? false;

  if (isEnabledForAnyFacility === undefined) {
    return undefined;
  }
  return isEnabledForAnyFacility && canViewCases;
};
